import React from 'react';
import EventTemplateHomePage from '../components/event-templates-catalog/HomePage/HomePage';

export const HomePage: React.FC = () => {
  return <EventTemplateHomePage />;
};
